import { filter, includes, isEmpty } from 'lodash';

/**
 * Test if a squiggly is on our list of supported squigglies
 * @category Getters
 * @category Squiggly
 */
export const getSquiggliesNotSupported = (
  text: string,
  squiggliesSupported: string[],
  ignoreDynamicSquigglies?: boolean,
) => {
  if (!text || isEmpty(squiggliesSupported)) {
    return [];
  }
  let squiggliesNotSupported = filter(
    text.match(/({{[^}]+}})/gm),
    (squiggly) => !includes(squiggliesSupported, squiggly),
  );
  if (ignoreDynamicSquigglies) {
    squiggliesNotSupported = filter(
      squiggliesNotSupported,
      (squiggly) => !/custom-form/.test(squiggly),
    );
  }
  return squiggliesNotSupported;
};
